/* eslint-disable max-len */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavController, ToastController } from '@ionic/angular';
import { AngularFirestore } from '@angular/fire/firestore';
import { NotificationsService } from '../../services/notifications.service';
import { AuthService } from 'src/app/services/auth.service';
import firebase from 'firebase/app';
import 'firebase/firestore';

@Component({
  selector: 'app-messages',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
})
export class MessageComponent implements OnInit {
  id;
  unsub1;
  chat;
  message;
  currentUser = this.authService.currentUser;
  chatUser;
  unsub2;
  unsub3;
  tfModel;
  constructor(
    public firestore: AngularFirestore,
    public authService: AuthService,
    public route: ActivatedRoute,
    public navController: NavController,
    public notificationsService: NotificationsService,
    public toastController: ToastController
  ) {
    if (this.route.snapshot.params.id) {
      this.id = this.route.snapshot.params.id;
    }
  }

  async ngOnInit() {
    this.unsub3 = this.authService.currentAccount.subscribe(async (currentUser) => { this.currentUser = currentUser; });
    this.getChats();
  }

  async getChatUserSubscription(id: string) {
    const q = this.firestore.collection('accounts', ref => ref.where('id', '==', id));
    this.unsub1 = q.snapshotChanges().subscribe(async (snapshot) => {
      snapshot.forEach(async (change) => {
        if (change.type === 'modified') {
          const user: any = change.payload.doc.data();
          user.id = change.payload.doc.id;
          this.chatUser = user;
        }
      });
    });
  }

  openProfile(user: any) {
    this.navController.navigateRoot(['/profile', user.uid]);
  }

  async getChats() {
    this.unsub2 = this.firestore.collection('chats').doc(this.id).snapshotChanges().subscribe(async (docRef) => {
      const chat: any = docRef.payload.data();
      chat.id = docRef.payload.id;
      chat.uids = chat.users;

      if (chat.users && chat.users.length > 0) {
        const q1 = this.firestore.collection('accounts', ref => ref.where(firebase.firestore.FieldPath.documentId(), 'in', chat.users));
        const querySnapshot = await q1.get().toPromise();
        querySnapshot.forEach((doc1) => {
          console.log(doc1.id, ' => ', doc1.data());
          const user: any = { id: doc1.id, ...(doc1.data() as any) };
          const index = chat.users.indexOf(user.id);
          if (!chat.usersData) { chat.usersData = []; }
          chat.usersData[index] = user;
          if (user.id !== this.currentUser.id) {
            this.chatUser = user;
            this.getChatUserSubscription(user.id);
          }
        });
      }

      this.chat = chat;
      setTimeout(() => {
        if (this.chat?.messages?.length > 0) {
          document.getElementById(`message-box-${this.chat.messages.length - 1}`)?.scrollIntoView({ behavior: 'smooth' });
        }
      }, 1000);
    });
  }

  async send() {
    if (this.message && this.message.length > 0) {
      console.log(this.chat, this.currentUser.uid, this.chat.uids.indexOf(this.currentUser.uid));
      const message = {
        user: this.currentUser.id,
        userKey: this.chat.uids.indexOf(this.currentUser.id),
        content: this.message,
        timestamp: new Date(),
      };
      const docRef = this.firestore.collection('chats').doc(this.id);
      // Atomically add a new region to the "regions" array field.
      await docRef.update({
        messages: firebase.firestore.FieldValue.arrayUnion(message)
      });
      this.notificationsService.sendNotification(`Message from - ${this.currentUser.displayName}`, this.message, {
        notificationToken: this.chatUser.notificationToken,
        type: 'message',
        by: this.currentUser.id,
        to: this.chatUser.id,
        redirectURL: '/message/' + this.id,
      }, this.currentUser.photoURL, 'message', undefined);
      this.message = '';
    } else {

    }
  }

  async presentToast(message: string) {
    const toast = await this.toastController.create({
      message,
      duration: 3000,
      position: 'top',
    });
    toast.present();
  }


  backBtn() {
    this.navController.back();
  }

  ionviewDidLeave() {
    if (this.unsub1) {this.unsub1.unsubscribe();}
    if (this.unsub2) {this.unsub2.unsubscribe();}
    if (this.unsub3) {this.unsub3.unsubscribe();}
  }


}
